







































import {Component, Vue} from 'vue-property-decorator';
import {httpClient} from '@/api/baseApi';
import {DataTableHeader} from 'vuetify';
import Card from '@c/Card.vue';
import Loading from '@c/controls/Loading.vue';
import {getDateWithTime} from '@/utils/dateTimeUtils';
import diagtaskStoreModule from '@/store/modules/diagtaskModule';
import bearingtasksStoreModule from '@/store/modules/bearingtasksModule';

@Component({
  components: {
    Card,
    Loading,
  },
})
export default class StateMonitor extends Vue {
  // Показатели загрузки данных и ошибки
  loading = true;
  error = false;

  state_data: any[] = [];

  /* пример данных мониторинга
  state = {
    data: [
      {
        'aw_start': 1710018000000.0,
        'aw_end': 1710032400000.0,
        'st_work': 1200.0,
        'nonst_work': 4200.0,
        'idle': 9000.0,
        'undef': 0.0,
        'anomaly_score': -0.002630631002020767,
        'stable_work_ratio': 0.1764704844291268,
        'mean_rms_x': 9.031438806561635,
        'mean_rms_y': 3.6683107879834127,
        'mean_rms_z': 6.52122089942782,
        'std_rms_x': 3.7692153697350603,
        'std_rms_y': 1.5658861658007222,
        'std_rms_z': 2.009853305557535,
        'max_rms_x': 21.964415073394775,
        'max_rms_y': 12.827927112579346,
        'max_rms_z': 18.070165634155273,
        'mean_vel_x': 6.16963824132155,
        'mean_vel_y': 2.719700832181414,
        'mean_vel_z': 2.714208809956224,
        'max_vel_x': 18.072102069854736,
        'max_vel_y': 10.251958727836609,
        'max_vel_z': 6.258361101150513,
        'mean_dis_x': 24.22338213523229,
        'mean_dis_y': 24.390013967241558,
        'mean_dis_z': 13.346964433079673,
        'max_temp': 29.219353675842285,
        'HI_raw': 0.7058823788927183,
        'HI_smooth': 0.7058823788927183,
        'current_state_code': 1,
        'trend_state_code': 0,
      },
    ],
  };
*/

  stateMonitorHeaders: DataTableHeader[] = [
    {
      text: 'Дата',
      value: 'aw_time',
      sortable: true,
    },
    {
      text: 'Индекс состояния',
      value: 'HI_smooth',
      sortable: false,
    },
    {
      text: 'Состояние',
      value: 'current_state',
      sortable: false,
    },
    {
      text: 'Тенденция',
      value: 'trend_state',
      sortable: false,
    },
    {
      text: 'Накоплено моточасов',
      value: 'work_interval',
      sortable: false,
    },
    {
      text: 'Аномалии в данных',
      value: 'anomaly_score',
      sortable: false,
    },
    {
      text: 'Ускорение xyz СКЗ 10-1К',
      value: 'mean_rms',
      sortable: false,
    },
    {
      text: 'Скорость xyz СКЗ 10-1К',
      value: 'mean_vel',
      sortable: false,
    },
    {
      text: 'Температура',
      value: 'max_temp',
      sortable: false,
    },
  ];

  state_codes = ['нормально', 'допустимо', 'требует мер', 'требует мер!'];

  async created() {
    try {
      const nodeId = Number(this.$route.params.id);
      const {data} = await httpClient.get<[]>(`nodes_rel/${nodeId}/bearing-tasks/`);
      if (data) {
        const bearingtasks = data as any;
        for (const item of bearingtasks) {
          const {data} = await bearingtasksStoreModule.getById(item.id);
          const pmodule = data as any;

          const records = await diagtaskStoreModule.getLastEvents({
            id: pmodule.span_node_id as number,
            eventType: 'value_changed',
            limit: 6,
          });
          if (!records) continue;

          const headers: {[key: string]: number} = {};
          records[1].forEach((val: any, index: number) => {
            headers[val[0]] = index;
          });

          records[0].forEach((ev: any) => {
            const el: {[index: string]: any} = {};
            for (let i = 0; i < records[1].length; i++) {
              el[records[1][i][0]] = Number(ev[i]);
            }
            this.state_data.push({
              aw_time: getDateWithTime(el.aw_end),
              HI_smooth: el.hi_smooth.toFixed(3),
              current_state: this.state_codes[el.current_state_code],
              trend_state:
                el.trend_state_code < 0
                  ? 'улучшается'
                  : el.trend_state_code > 0
                  ? 'ухудшается'
                  : 'стабильно',
              work_interval: ((el.st_work + el.nonst_work) / 3600).toFixed(2),
              anomaly_score:
                (el.anomaly_score < -0.1 ? 'есть (' : 'нет (') + el.anomaly_score.toFixed(3) + ')',
              mean_rms:
                el.mean_rms_x.toFixed(1) +
                ' | ' +
                el.mean_rms_y.toFixed(1) +
                ' | ' +
                el.mean_rms_z.toFixed(1),
              mean_vel:
                el.mean_vel_x.toFixed(1) +
                ' | ' +
                el.mean_vel_y.toFixed(1) +
                ' | ' +
                el.mean_vel_z.toFixed(1),
              max_temp: el.max_temp.toFixed(1),
            });
          });
        }
      }
    } catch (errorData) {
      if (Vue.config.devtools) {
        // печатаем ошибку в режиме разработки
        console.error(errorData);
      }
      this.error = true;
    } finally {
      this.loading = false;
    }
  }
}
